import { Box, Grid, TextField, Select, MenuItem, Button, Skeleton, Modal, IconButton, CircularProgress, Checkbox, FormControlLabel, Popover } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BuyRequestStatus, TransactionType } from "../../../constants/enums";
import { DataGridPremium, GridActionsCellItem, GridDeleteIcon } from "@mui/x-data-grid-premium";
import { STN_FE_URL } from '../../../constants';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useEventsMutation, useLazyGetBuyRequestQuery, useLazyGetBuyRequestsAssignedManagerQuery, useLazyGetSwarmsQuery } from '../../../services/swarmsApi';
import { selectAllBuyRequests, selectAllEvents, selectAllSwarms, selectAllReasons, setBuyRequests } from "../../../store/slices/swarms";
import { useLazyGetPurchaseQuickViewQuery } from '../../../services/purchaseApi';
import { useCreateTransactionAdjustmentMutation, useEditTransactionAdjustmentMutation, useLazyGetTransactionsQuery } from '../../../services/PaymentToolApi';
import { useAccountsCacheQuery } from "../../../services/accountsApi";
import Notification from './../../../components/Notification';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined'
import { copyToClipBoard } from "../../../utils";
import { DEFAULT_REQUEST_HISTORY_GRID_STYLE, REQUEST_HISTORY_GRID_COLUMN } from "./RequestHistoryGridColumn";
import useQueryParams from "../../../customHooks/useQueryParams";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

import AddIcon from '@mui/icons-material/Add';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddBonusTransactionModal from "../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/AddBonusTransactionModal";
import { AddErrorTransactionModal } from "../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/AddErrorTransactionModal";
import EditBonusTransactionModal from "../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/EditBonusTransactionModal";
import {EditErrorTransactionModal} from "../../adminToolsTabs/payoutManagement/PaymentsToolGrids/components/EditErrorTransactionModal";
import { splitRequest } from "../../../utils/requestUtils";
const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
};

const AdditionalInfoStyles = {
  bgcolor: 'background.paper',
  borderRadius: '1em',
  padding: '1em',
}


const AdditionalInfoPopper = ({ open, anchorEl, additionalInfo, onClose }) => {

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      PaperProps={{
        onMouseLeave: onClose,
        style: AdditionalInfoStyles
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
        {
          additionalInfo?.orderNumber
            ?
            (
              <Box>
                <Box>
                  <span style={{ color: "var(--orange)", fontWeight: '600' }}>Order Number: </span>
                  <span>{additionalInfo.orderNumber}</span>
                  <span>
                    <ContentCopyOutlinedIcon 
                      onClick={_ => { copyToClipBoard(additionalInfo.orderNumber); onClose() }}
                      style={{color: "var(--orange)", fontSize: "1em", margin: "0 0 0 0.5em", verticalAlign: "middle", cursor: "pointer"}}
                    />
                  </span>
                </Box>
                <Box>
                  <span style={{ color: "var(--orange)", fontWeight: '600' }}>Buying Email used: </span>
                  <span>{additionalInfo.buyingEmailAddress}</span>
                  <span>
                    <ContentCopyOutlinedIcon 
                      onClick={_ => { copyToClipBoard(additionalInfo.buyingEmailAddress); onClose() }}
                      style={{color: "var(--orange)", fontSize: "1em", margin: '0 0 0 0.5em', verticalAlign: "middle", cursor: "pointer" }}
                    />
                  </span>
                </Box>
              </Box>
            )
            :
            <></>
        }
      </Box>
    </Popover>
  )
}


function createButtonStyle(color) {
  return {
    color: 'black', // changes the text color
    '& .MuiButton-startIcon': {
      color: color, // ensures the icon color is green
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  }
}

function arrayToDictionary(array, key = 'id') {
  return Object.assign({}, ...array.map((x) => ({ [x[key]]: x })))
}

function containsOnlyDigits(string) {
  return /^[0-9]+$/.test(string);
}

const RequestHistory = ({ setShowError }) => {
  const sourceCount = 3;
  const location = useLocation();
  const querys = new URLSearchParams(location.search);
  const history = useHistory();

  useEffect(() => {
    const handleBackButton = () => {
      const period = querys.get("period");
      const user = querys.get("user");
      history.push(`/dashboard/admintools?tab_index=4&period=${period}&user=${user}`);
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [history]);

  const [searchParams, setSearchParams] = useQueryParams({ tab_index: 0, search_value: null, is_today_request: true });

  const [filters, setFilters] = useState({ searchStatusId: 1, searchValue: null, isTodayRequest: true });
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
  const [notification, setNotification] = useState({ status: "ERROR", text: "", snackBarOpenProp: false, });
  const [rows, setRows] = useState([]);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [isLoadingData, setIsLoadingData] = useState(true);
  const [totalElements, setTotalElements] = useState(0);
  const [getBuyRequests] = useLazyGetBuyRequestQuery();
  const [getPurchases] = useLazyGetPurchaseQuickViewQuery();
  const [getRelatedTransaction, { data: relatedTransactionRes }] = useLazyGetTransactionsQuery();
  const [getTransaction] = useLazyGetTransactionsQuery();

  const [displayBuyRequest, setDisplayBuyRequest] = useState([]);
  const [displayBuyRequestPaged, setDisplayBuyRequestPaged] = useState([]);

  const [displayPurchases, setDisplayPurchases] = useState([]);
  const [isLoadingPurchases, setIsLoadingPurchases] = useState(false);

  const buyRequests = useSelector(selectAllBuyRequests);
  const swarms = useSelector(selectAllSwarms);
  const events = useSelector(selectAllEvents);
  const reasons = useSelector(selectAllReasons);

  const [getAssignedManager, { data: assignedManagers }] = useLazyGetBuyRequestsAssignedManagerQuery();
  const [isLoadingAssignedManagers, setIsLoadingAssignedManagers] = useState({ isLoading: false, isError: false, errorMessage: null });

  const [getSwarmEvents] = useEventsMutation();
  const [getSwarms] = useLazyGetSwarmsQuery();
  const [getSearchPurchases] = useLazyGetPurchaseQuickViewQuery();
  const dispatch = useDispatch();

  const [gridStyle, setGridStyle] = useState(null);
  const [isFirstGridLoad, setIsFirstGridLoad] = useState(true);
  const [columns, setColums] = useState([])
  const [displayColumns, setDisplayColums] = useState([])

  const [sortModel, setSortModel] = useState([]);
  const [sortEnabled, setSortEnabled] = useState(true);

  const { data: usersRes, isSuccess: isUsersSuccess, IsError: usUsersError, isLoading: isUsersLoadings } = useAccountsCacheQuery();
  const userLookUpTable = useMemo(() => {
    if (isUsersSuccess) {
      return arrayToDictionary(usersRes.res.accounts);
    }
  }, [isUsersSuccess]);

  const [isAdditionalInfoOpened, setIsAdditionalInfoOpened] = useState(false);
  const [isAddTransactionMenuOpened, setIsAddTransactionMenuOpened] = useState(false);
  const [rowAnchorEl, setRowAnchorEl] = useState(null);
  const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState(null);

  const AddTransactionMenuPopper = ({ open, anchorEl, additionalInfo, onClose }) => {

    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        PaperProps={{
          onMouseLeave: onClose,
          style: AdditionalInfoStyles
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>

          <Box>
            <Button variant="text" startIcon={<AddIcon />} sx={createButtonStyle('green')} onClick={() => { setIsAddTransactionMenuOpened(false); setModalIsOpen('addBonusTransaction') }}>
              Add New Bee Bonus
            </Button>
          </Box>

          <Box>
            <Button variant="text" startIcon={<HighlightOffIcon />} sx={createButtonStyle('red')} onClick={() => { setIsAddTransactionMenuOpened(false); setModalIsOpen("addErrorTransaction") }}>
              Add New Bee Error
            </Button>
          </Box>

        </Box>
      </Popover>
    )
  }

  function EventDateCell(date) {
    const eventDate = new Date(date);

    const options = {
      weekday: "short",
      month: "numeric",
      day: "numeric",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = eventDate.toLocaleString("en-US", options)
      .replace(/(?<=\b)(Mon|Tue|Wed|Thu|Fri|Sat|Sun)(?=\b)/g, match => {
        switch (match) {
          case "Mon":
            return "Mo";
          case "Tue":
            return "Tu";
          case "Wed":
            return "We";
          case "Thu":
            return "Th";
          case "Fri":
            return "Fr";
          case "Sat":
            return "Sa";
          case "Sun":
            return "Su";
          default:
            return match;
        }
      })
      .replace(",", "") // Remove the comma after the weekday
      .replace(/,\s/g, " ") // Remove the comma after the date
      .replace(/\//g, "-") // Replace '/' with '-'
      .replace(/\b0/g, "") // Remove leading zeros from the date
      .replace(":0 ", " "); // Remove the minutes part when it's an oclock time

    return formattedDate;
  }

  const updateColumnsForUser = (columns) => {
    sessionStorage.setItem('request-history-columns', JSON.stringify(columns));
  }

  useEffect(() => {
    const filtersNew = ({
      ...filters,
      searchValue: searchParams?.search_value ?? filters.searchValue,
      isTodayRequest: searchParams?.is_today_request ?? filters.isTodayRequest
    }); 
    setFilters(filtersNew)

    if (searchParams?.is_today_request) {
      setSortEnabled(searchParams.is_today_request)
    }

    setSearchParams({tab_index: searchParams?.tab_index});

    onSearch(filtersNew, paginationModel, sortModel);
  }, [searchParams])

  useEffect(() => {
    if (!sessionStorage.getItem("request-history-columns")) {
      updateColumnsForUser(DEFAULT_REQUEST_HISTORY_GRID_STYLE());
    }
    const sessionGridStyles = JSON.parse(sessionStorage.getItem("request-history-columns"))

    setGridStyle([...sessionGridStyles]);
  }, [])

  useEffect(() => {
    if (gridStyle == null || gridStyle == undefined)
      return;

    let displayColumns = [];
    let hideColumns = {};

    const sortedColumns = [...gridStyle].sort((a, b) => a.index - b.index);
    sortedColumns.forEach(column => {
      let displayColumn = columnsDefinition[column.name];

      if (column.width) {
        displayColumn.flex = 0;
        displayColumn.width = column.width;
      }

      hideColumns[displayColumn.field] = column.mustBeVisible;
      displayColumns.push(displayColumn);
    });

    setColums(displayColumns);

    if (!isFirstGridLoad) {
      updateColumnsForUser(gridStyle);
    }
    setIsFirstGridLoad(false);
  }, [gridStyle])

  useEffect(() => {
    if (!columns)
      return;

    const newColumns = columns.map(column => {
      const newColumn = { ...column }

      const [key] = Object.entries(columnsDefinition).find(([key, col]) => col.field === newColumn.field)

      if (columnsAvailableForSort.includes(key))
        newColumn.sortable = sortEnabled

      return newColumn;
    })

    setDisplayColums(newColumns)
  }, [columns, sortEnabled])

  useEffect(async () => {
    if (!displayBuyRequestPaged)
      return;

    // const completedRequestsIds = displayBuyRequestPaged.filter(x => x.swarmResolutionTypeId === BuyRequestStatus.Completed).map(x => `jobId=${x.id}`);
    // let queryString = completedRequestsIds.join('&');
    let completedRequestsIds = displayBuyRequestPaged.filter(x => x.swarmResolutionTypeId === BuyRequestStatus.Completed).map(x => x.id);
    
    if (completedRequestsIds.length > 0) {
      // queryString = '?' + queryString + '&requestTypeID=2';
      try {
        setIsLoadingPurchases(true);
        // const purchases = await getPurchases(queryString, false).unwrap()
        const purchases = await splitRequest(getPurchases, completedRequestsIds, "jobId", 100, '&requestTypeID=2');
        setDisplayPurchases([...purchases]);
        setIsLoadingPurchases(false);
      }
      catch (error) {
        if (error.status == 401) return;
        throw error;
      }
    }
  }, [displayBuyRequestPaged])

  useEffect(async () => {
    if (!displayBuyRequestPaged)
      return;

    const brIds = displayBuyRequestPaged.map(x => `buyRequestIds=${x.id}`)
    const queryString = brIds.join('&');

    if (brIds.length > 0) {
      try {
        setIsLoadingAssignedManagers({ isLoading: true, isError: false });
        await getAssignedManager(queryString).unwrap();
        setIsLoadingAssignedManagers({ isLoading: false, isError: false })
      } catch (error) {
        if (error.status == 401) return;
        if (error.status == 400) {
          setIsLoadingAssignedManagers({ isLoading: false, isError: true, errorMessage: error.data.message })
          return;
        }
        throw error;
      }
    }

  }, [displayBuyRequestPaged])

  useEffect(() => {
    if (!displayPurchases)
      return;

    const relatedTransactionsIds = displayPurchases.filter(p => p.transactionID).map(p => p.transactionID)

    if (relatedTransactionsIds.length > 0) {
      getRelatedTransaction({ relatedTransactionID: relatedTransactionsIds, isDeleted: false })
    }
  }, [displayPurchases])

  useEffect(() => {
    if (!displayBuyRequest)
      return;

    const updatedGrid = displayBuyRequest.map(br => buyRequests.find(x => x.id === br.id)).filter(x => !!x);
    setDisplayBuyRequest(updatedGrid);
  }, [buyRequests])

  useEffect(() => {
    const pageSkip = paginationModel.page;
    let brArr = [...displayBuyRequest];

    if (!sortEnabled || (sortEnabled && (!sortModel || sortModel.length === 0))) {
      brArr.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
    }

    brArr = brArr.slice(paginationModel.pageSize * pageSkip, paginationModel.pageSize * pageSkip + paginationModel.pageSize);
    setDisplayBuyRequestPaged(brArr);
  }, [displayBuyRequest])

  useEffect(() => {
    const rows = displayBuyRequestPaged?.map((br) => mapBuyRequestToRow(br, swarms, events, reasons, displayPurchases, relatedTransactionRes, assignedManagers, isLoadingPurchases, isUsersLoadings, isLoadingAssignedManagers)) || [];
    setRows([...rows])
  }, [displayBuyRequestPaged, swarms, events, reasons, displayPurchases, relatedTransactionRes, assignedManagers, isLoadingPurchases, isUsersLoadings, isLoadingAssignedManagers])

  const mapBuyRequestToRow = (br, swarms, events, reasons, purchases, relatedTransactions, assignedManagers, isLoadingPurchases, isUsersLoadings, isLoadingAssignedManagers) => {
    const brSwarm = swarms?.find((s) => s.id === br.swarmId);
    const brEvent = events?.find((e) => e?.bteId === brSwarm?.bteId);
    const reason = reasons?.find(r => r.id === br.reasonId)?.name;
    const purchase = purchases?.find(p => p.requestID === br.id);
    const relatedTransaction = relatedTransactions?.find(rt => rt.relatedTransactionID === purchase?.transactionID);
    const manager = assignedManagers?.find(am => am.buyRequestId === br.id);

    return {
      eventName: brEvent?.name,
      venueName: !brEvent?.venue?.name ? null : brEvent?.venue?.name + ', ' + brEvent?.venue?.city,
      eventDate: brEvent?.date,
      purchaseDate: purchase?.createdOn,
      requestStatusId: br.swarmResolutionTypeId,
      buyerName: getNameOfCurrentAdminInCharge(br.userId),
      buyerID: br.userId,
      quantity: br.quantity,
      section: br.section,
      row: br.row,
      seats: br.seats,
      totalCost: `$${br.totalCost}`,
      pricePerTicket: `$${(br.totalCost / br.quantity).toFixed(2)}`,
      reason: reason,
      reward: `$${br.swarmRewardTypeId === 1 ? (br.rewardAmout / br.quantity) : br.rewardAmout} ${br.swarmRewardTypeId === 1 ? `Per Ticket` : `Total`}`,
      assignedManager: getAssignerManagerText(manager),
      additionalParams: {
        orderNumber: purchase?.orderNumber,
        buyingEmailAddress: purchase?.buyingEmailAddress
      },

      buyRequestId: br.id,
      purchaseId: purchase?.id,
      rewardTotal: br.rewardAmout,
      stnPurchaseId: purchase?.stnPurchaseId,
      purchaseTransactionId: purchase?.transactionID,
      relatedTransactionId: relatedTransaction?.id,
      relatedTransaction: relatedTransaction,
      bteId: brSwarm?.bteId,
      isLoadingPurchases: isLoadingPurchases,
      isUsersLoadings: isUsersLoadings,
      relatedTransactionLoading: !!relatedTransactions,
      isLoadingAssignedManagers: isLoadingAssignedManagers
    };
  };

  const getNameOfCurrentAdminInCharge = (params) => {
    if (!userLookUpTable)
      return null;

    let name = userLookUpTable[params];
    if (name)
      return `${name.firstName} ${name.lastName}`;
    else
      return null;
  }

  const getAssignerManagerText = (params) => {
    if (!userLookUpTable || !params || !params?.managerId)
      return null;

    const approved = params.approved ? "APPROVED" : "DISAPPROVED";
    const managerName = userLookUpTable[params.managerId].firstName;

    return `${approved} by ${managerName}`;
  }

  const onSearch = async (filters, paginationModel, sortModel, isPageChange) => {
    setIsLoadingData(true);
    let isLoadingDataSetToFalse = false;
    if (!isPageChange) {
      dispatch(setBuyRequests([]));
      setDisplayBuyRequest([]);
    }
    const searchPromises = await SearchByValue(filters, paginationModel, sortModel);

    // Attach a `finally` handler to each promise
    searchPromises.forEach(promise => {
      promise.finally(() => {
        if (!isLoadingDataSetToFalse) {
          setIsLoadingData(false);
          isLoadingDataSetToFalse = true; // Ensure it runs only once
        }
      });
    });

    await SearchByValue(filters, paginationModel, sortModel);
    try {
      await Promise.all(searchPromises);
    } finally {
      // In case no promises settled (unlikely), ensure `isLoadingData` is false
      if (!isLoadingDataSetToFalse) {
        setIsLoadingData(false);
      }
    }
  }

  const SearchByValue = async (filters, paginationModel, sortModel) => {
    setTotalElements(0);

    const searchStatuses = dropdownSearchValue[filters?.searchStatusId || 1].value;

    const pageSize = paginationModel.pageSize * sourceCount;
    const currentPage = ~~(paginationModel.page / sourceCount);

    const searchPromices = [];

    if (!filters.isTodayRequest) {
      searchPromices.push(searchByEventData(filters, pageSize, currentPage, searchStatuses));
      searchPromices.push(searchByBuyerName(filters, pageSize, currentPage, searchStatuses));
      searchPromices.push(searchByPurchase(filters, pageSize, currentPage, searchStatuses));
    } else {
      searchPromices.push(searchForToday(filters, pageSize, currentPage, searchStatuses, sortModel))
    }

    return searchPromices;
  }

  const searchByEventData = async (filters, pageSize, currentPage, searchStatuses) => {
    const eventSearch = [];

    if (!filters.searchValue)
      return;

    const searchCondition = filters.searchValue.startsWith('*') ? "contains" : "startsWith";
    const searchString = filters.searchValue.startsWith('*') ? filters.searchValue.substring(1) : filters.searchValue;

    let searchDate = searchString;
    const parcedDate = new Date(searchString);

    if (!isNaN(parcedDate)) {
      const searchDate = formatEventDate(parcedDate, searchString.includes(':'))

      eventSearch.push({
        Name: "date",
        filterType: searchCondition,
        logicConditionType: "or",
        condition: searchDate,
      });
    }

    eventSearch.push({
      Name: "name",
      filterType: searchCondition,
      logicConditionType: "or",
      condition: searchString,
    });

    eventSearch.push({
      Name: "venue",
      filterType: searchCondition,
      logicConditionType: "or",
      condition: searchString,
    })

    const pageSizeEvent = 500;
    const maxRequestsToApi = 5;

    try {
      const res = await getSwarmEvents({
        PageNo: 1,
        RecordsLimit: pageSizeEvent,
        orderColumns: [{ Name: "date", orderType: "desc" }],
        filterColumns: eventSearch,
      }, false).unwrap();

      if (res.events.length > 0) {
        const bteIdsQueryString = res.events.map(e => `bteId=${e.bteId}`).join('&');
        const swarms = await getSwarms(`?${bteIdsQueryString}&PageSize=${pageSizeEvent}`, false).unwrap();
        if (swarms.swarms.length > 0) {
          const swarmsIds = swarms.swarms.map(x => x.id);
          const result = await getBuyRequests({ SwarmId: swarmsIds, SwarmResolutionTypeId: searchStatuses, IsTodayRequest: filters.isTodayRequest, PageNumber: currentPage, PageSize: pageSize, extraOptions: true }).unwrap();
          UpdateDisplayBuyRequest(result);
        }
      }

      const totalCount = ~~(res.totalCount / pageSizeEvent) + 1;

      for (let index = 2; index <= totalCount && index <= maxRequestsToApi; index++) {
        const res = await getSwarmEvents({
          PageNo: index,
          RecordsLimit: pageSizeEvent,
          orderColumns: [{ Name: "date", orderType: "desc" }],
          filterColumns: eventSearch,
        }, false).unwrap();


        if (res.events.length > 0) {
          const bteIdsQueryString = res.events.map(e => `bteId=${e.bteId}`).join('&');
          const swarms = await getSwarms(`?${bteIdsQueryString}&PageSize=${pageSizeEvent}`, false).unwrap();
          if (swarms.swarms.length > 0) {
            const swarmsIds = swarms.swarms.map(x => x.id);
            const result = await getBuyRequests({ SwarmId: swarmsIds, SwarmResolutionTypeId: searchStatuses, IsTodayRequest: filters.isTodayRequest, PageNumber: currentPage, PageSize: pageSize, extraOptions: true }).unwrap();
            UpdateDisplayBuyRequest(result);
          }
        }
      }

    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
  }

  const formatEventDate = (date, useTime) => {
    const convertedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();

    if (useTime) {
      const splitedDate = convertedDate.split("T");

      return splitedDate[0] + ' ' + splitedDate[1].slice(0, -1)
    }
    else {
      return convertedDate.split("T")[0];
    }
  }

  const searchByBuyerName = async (filters, pageSize, currentPage, searchStatuses) => {
    let searchModel = { SwarmResolutionTypeId: searchStatuses, IsTodayRequest: filters.isTodayRequest, PageNumber: currentPage, PageSize: pageSize, extraOptions: true };

    if (filters.searchValue)
      searchModel = { ...searchModel, BuyerName: filters.searchValue }

    try {
      const result = await getBuyRequests(searchModel).unwrap();
      UpdateDisplayBuyRequest(result);
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
  }

  const searchByPurchase = async (filters, pageSize, currentPage, searchStatuses) => {
    if (!filters.searchValue)
      return;

    const [purchasesByDate, purchasesByTransactionId] = await Promise.all([
      searchPurchasesByDate(filters.searchValue, currentPage, pageSize),
      searchPurchasesByTransactionId(filters.searchValue, currentPage, pageSize)
    ]);

    const purchases = [...purchasesByDate];
    purchasesByTransactionId.forEach(purchase => {
      if (!purchases.find(p => p.id === purchase.id)) {
        purchases.push(purchase);
      }
    });

    try {
      if (purchases.length > 0) {
        const brIds = purchases.map(x => x.requestID);
        const result = await getBuyRequests({ BuyRequestId: brIds, SwarmResolutionTypeId: searchStatuses, IsTodayRequest: filters.isTodayRequest, PageNumber: currentPage, PageSize: pageSize, extraOptions: true }).unwrap();
        UpdateDisplayBuyRequest(result);
      }
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
  }

  const searchPurchasesByDate = async (searchString, currentPage, pageSize) => {
    const parcedDate = new Date(searchString);

    if (isNaN(parcedDate))
      return [];

    const searchDate = formatDate(parcedDate, searchString.includes(':'));

    try {
      return await getSearchPurchases(`?PurchaseDate=${searchDate}&RequestTypeID=2&PageNumber=${currentPage + 1}&PageSize=${pageSize}`, false).unwrap();
    } catch (error) {
      if (error.status == 401) return [];
      throw error;
    }
  }

  const searchPurchasesByTransactionId = async (searchString, currentPage, pageSize) => {
    if (!containsOnlyDigits(searchString)) 
      return [];

    try {
      const transactions = await getTransaction({ TransactionID: searchString, isDeleted: false }, false).unwrap();

      if (!transactions || transactions.length == 0)
        return [];

      const purchaseId = transactions[0].purchaseID;

      return await getSearchPurchases(`?PurchaseId=${purchaseId}&RequestTypeID=2&PageNumber=${currentPage + 1}&PageSize=${pageSize}`, false).unwrap();
    } catch (error) {
      if (error.status == 401) return [];
      throw error;
    }
  }

  const searchForToday = async (filters, pageSize, currentPage, searchStatuses, sortModel) => {
    let searchModel = { SwarmResolutionTypeId: searchStatuses, IsTodayRequest: filters.isTodayRequest, extraOptions: true }

    let allBuyReqests = [];

    try {
      allBuyReqests = await getBuyRequests(searchModel).unwrap();
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }

    const swarmEvent = await fetchSwarmEventDetails(allBuyReqests.buyRequests);
    const purchasesWithDates = await fetchPurchasesWithDates(allBuyReqests.buyRequests);

    const brForFiltration = allBuyReqests.buyRequests.map(br => mapBuyRequestToFilteredData(br, swarmEvent, purchasesWithDates));

    const filteredBuyRequest = applyFilters(filters, brForFiltration);

    if (sortEnabled && sortModel && sortModel.length > 0) {
      applySort(filteredBuyRequest, sortModel);
    }

    setTotalElements(filteredBuyRequest.length);
    setDisplayBuyRequest(filteredBuyRequest.map(x => x.buyRequest));
  }

  const fetchSwarmEventDetails = async (allBuyRequests) => {
    if (!allBuyRequests || allBuyRequests.length === 0)
      return {};

    const swarmIdsQueryString = allBuyRequests.map(BR => BR.swarmId).filter((value, index, self) => self.indexOf(value) === index).map(id => `Id=${id}`).join('&');
    let swarmsWithEvents;
    try {
      swarmsWithEvents = await getSwarms(`?${swarmIdsQueryString}`).unwrap();
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
    const swarmEvent = {};
    swarmsWithEvents.swarms.forEach(swarm => {
      const event = swarmsWithEvents.events.find(x => x.bteId === swarm.bteId);
      swarmEvent[swarm.id] = event;
    });
    return swarmEvent;
  };

  const fetchPurchasesWithDates = async (allBuyRequests) => {
    if (!allBuyRequests || allBuyRequests.length === 0)
      return [];

    let purchaseQueryString = allBuyRequests.filter(x => x.swarmResolutionTypeId === BuyRequestStatus.Completed).map(x => `jobId=${x.id}`).join('&');
    purchaseQueryString = '?' + purchaseQueryString + '&requestTypeID=2';
    try {
      return await getPurchases(purchaseQueryString, false).unwrap();
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
  };

  const mapBuyRequestToFilteredData = (br, swarmEvent, purchasesWithDates) => {
    const eventData = swarmEvent[br.swarmId];
    const purchaseData = purchasesWithDates.find(p => p.requestID === br.id);
    const buyerNameInfo = br.swarmResolutionTypeId !== BuyRequestStatus.Pending ? getNameOfCurrentAdminInCharge(br.userId) : null;

    return {
      eventName: eventData?.name,
      venueName: eventData?.venue?.name + ', ' + eventData?.venue?.city,
      eventDate: eventData ? new Date(eventData?.date) : null,
      formattedEventDate: EventDateCell(eventData?.date),
      purchaseDate: purchaseData ? new Date(purchaseData?.createdOn) : null,
      formattedPurchaseDate: EventDateCell(purchaseData?.createdOn),
      buyerName: buyerNameInfo,
      transationId: purchaseData?.transactionID,
      buyRequest: br
    };
  };

  const applyFilters = (filters, brForFiltration) => {
    if (filters.searchValue) {
      
      const searchCondition = filters.searchValue.startsWith('*') ? "contains" : "startsWith";
      const searchString = filters.searchValue.startsWith('*') ? filters.searchValue.substring(1).toUpperCase() : filters.searchValue.toUpperCase();
    
      if (searchCondition === "contains") {
        return brForFiltration.filter(br =>
          br.eventName?.toUpperCase().includes(searchString) ||
          br.venueName?.toUpperCase().includes(searchString) ||
          br.formattedEventDate?.toUpperCase().includes(searchString) ||
          br.formattedPurchaseDate?.toUpperCase().includes(searchString) ||
          br.buyerName?.toUpperCase().includes(searchString)
        );
      } else if (searchCondition === "startsWith") {
        return brForFiltration.filter(br =>
          br.eventName?.toUpperCase().startsWith(searchString) ||
          br.venueName?.toUpperCase().startsWith(searchString) ||
          br.formattedEventDate?.toUpperCase().startsWith(searchString) ||
          br.formattedPurchaseDate?.toUpperCase().startsWith(searchString) ||
          br.buyerName?.toUpperCase().startsWith(searchString)
        );
      }

    } else {
      return [...brForFiltration];
    }
  };

  const applySort = (filteredBuyRequest, sortModel) => {
    const sortInfo = sortModel[0];

    const sortData = sortFunctions[sortInfo.field];
    filteredBuyRequest.sort((a, b) => sortData.sortFunc(a[sortData.fieldName], b[sortData.fieldName], sortInfo.sort));
  };

  const compareString = (a, b, sortOrder) => {
    if (a === null && b === null) return 0;
    if (a === null) return sortOrder === 'asc' ? 1 : -1;
    if (b === null) return sortOrder === 'asc' ? -1 : 1;
    return sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
  }

  const compareDates = (a, b, sortOrder) => {
    if (a === null && b === null) return 0;
    if (a === null) return sortOrder === 'asc' ? 1 : -1;
    if (b === null) return sortOrder === 'asc' ? -1 : 1;
    return sortOrder === 'asc' ? a - b : b - a;
  };

  function formatDate(date, useTime) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hour = date.getHours();
    const minute = date.getMinutes();
    const amPM = hour >= 12 ? 'PM' : 'AM';

    hour = hour % 12;
    hour = hour ? hour : 12;

    const formatedDate = day < 10 ? ' ' + day : day;
    const formattedHour = hour < 10 ? ' ' + hour : hour;
    const formattedMinute = minute < 10 ? '0' + minute : minute;

    if (useTime)
      return `${month} ${formatedDate} ${year} ${formattedHour}:${formattedMinute}${amPM}`;
    else
      return `${month} ${formatedDate} ${year}`;
  }

  const UpdateDisplayBuyRequest = (result) => {
    if (!result?.buyRequests?.length) return [];
    setDisplayBuyRequest((prev) => {
      const newItems = result?.buyRequests?.filter(br => prev.findIndex((s) => s.id && s.id === br.id) === -1);
      return [...prev, ...newItems]
    })
    setTotalElements((prev) => prev + result.totalCount);
  }

  const handleFiltersChange = (event) => {
    const { name, value } = event.target;
    setFilters(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const OpenEditTransactionModal = (relatedTransaction) => {
    // setEditModalData({open: true, relatedTransaction: relatedTransaction})
  }

  const onAdditionalInfoModalClick = (e, params) => {
    setRowAnchorEl(e.currentTarget);
    setSelectedAdditionalInfo(params);
    setIsAdditionalInfoOpened(true);
  }

  const onAddTransactionButtonClick = (e, params) => {
    setRowAnchorEl(e.currentTarget);
    setSelectedAdditionalInfo(params);
    setIsAddTransactionMenuOpened(true);
  }

  const onAdditionalInfoModalClosed = () => {
    setIsAdditionalInfoOpened(false);
    setRowAnchorEl(null);
    setSelectedAdditionalInfo(null);
  }

  const OnAddTransactionMenuClosed = () => {
    setIsAddTransactionMenuOpened(false);
    setRowAnchorEl(null);
  }

  const onEditTransactionClick = (params) => {
    let transactionID= params.row.relatedTransaction.transactionTypeID;
    console.log('transactionID', transactionID);
    console.log('TransactionType: ' , TransactionType)
    if(TransactionType.Bonus == transactionID){
      setModalIsOpen('editBonusTransaction');
    }
    else if(TransactionType.Penalty == transactionID){
      setModalIsOpen('editErrorTransaction');
    }
    else{
      alert('Transaction type not supported to be edited here: ' + transactionID);
    }
    setSelectedAdditionalInfo(params.row);
  }


  function renderEventDateCell(params, hideLoader) {
    if (!params.value && !hideLoader) {
      return <Skeleton variant="text" width="70%" />;
    }

    if (hideLoader && !params.value)
      return <></>

    return EventDateCell(params.value)
  }

  const dropdownSearchValue = {
    1: {
      text: "Show All Request",
      value: [BuyRequestStatus.Accepted, BuyRequestStatus.Rejected, BuyRequestStatus.Lost, BuyRequestStatus.Completed, BuyRequestStatus.Pending, BuyRequestStatus.CanceledByBee, BuyRequestStatus.OverTheLimit]
    },
    2: {
      text: "Show Only Completed Request",
      value: [BuyRequestStatus.Completed]
    },
    3: {
      text: "Show Only Lost Request",
      value: [BuyRequestStatus.Lost]
    },
    4: {
      text: "Show Only Pass Request",
      value: [BuyRequestStatus.Rejected]
    },
    5: {
      text: "Show Only Over The Limit Request",
      value: [BuyRequestStatus.OverTheLimit]
    },
    6: {
      text: "Show Only Cancel By Bee Request",
      value: [BuyRequestStatus.CanceledByBee]
    }
  };

  const columnsAvailableForSort = [
    REQUEST_HISTORY_GRID_COLUMN.EVENT_NAME,
    REQUEST_HISTORY_GRID_COLUMN.VENUE_NAME,
    REQUEST_HISTORY_GRID_COLUMN.EVENT_DATE,
    REQUEST_HISTORY_GRID_COLUMN.PURCHASE_DATE,
    REQUEST_HISTORY_GRID_COLUMN.BUYER_NAME
  ]

  const sortFunctions = {
    ["eventName"]: { fieldName: "eventName", sortFunc: compareString },
    ["venueName"]: { fieldName: "venueName", sortFunc: compareString },
    ["buyerName"]: { fieldName: "buyerName", sortFunc: compareString },
    ["eventDate"]: { fieldName: "eventDate", sortFunc: compareDates },
    ["purchaseDate"]: { fieldName: "purchaseDate", sortFunc: compareDates },
  }

  const displayStusName = {
    [BuyRequestStatus.Accepted]: { text: "APPROVED", className: "status-request-warning" },
    [BuyRequestStatus.Rejected]: { text: "REJECTED", className: "status-request-error" },
    [BuyRequestStatus.Lost]: { text: "LOST", className: "status-request-error" },
    [BuyRequestStatus.Completed]: { text: "COMPLETED", className: "status-request-success" },
    [BuyRequestStatus.Pending]: { text: "PENDING", className: "status-request-warning" },
    [BuyRequestStatus.CanceledByBee]: { text: "CANCELED BY BEE", className: "status-request-error" },
    [BuyRequestStatus.OverTheLimit]: { text: "OVER THE LIMIT", className: "status-request-warning" },
  }

  const columnsDefinition = {
    [REQUEST_HISTORY_GRID_COLUMN.EVENT_NAME]: {
      headerName: "EVENT",
      field: "eventName",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (!params.value)
          return <Skeleton variant="text" width="100%" />
        else {
          let baseURL = STN_FE_URL
          baseURL += '#/events-details';
          return params.row.bteId
            ?
            <a href={`${baseURL}/${params.row.bteId}`} target="_blank" rel="noreferrer">{params.value}</a>
            :
            params.value
        }
      }
    },
    [REQUEST_HISTORY_GRID_COLUMN.VENUE_NAME]: {
      headerName: "VENUE",
      field: "venueName",
      flex: 1,
      sortable: false,
      renderCell: v => !v.value ? <Skeleton variant="text" width="100%" /> : v.value
    },
    [REQUEST_HISTORY_GRID_COLUMN.EVENT_DATE]: {
      headerName: "EVENT DATE",
      field: "eventDate",
      sortable: false,
      flex: 0.6,
      headerAlign: 'center',
      renderCell: renderEventDateCell
    },
    [REQUEST_HISTORY_GRID_COLUMN.PURCHASE_DATE]: {
      headerName: "PURCHASE DATE",
      field: "purchaseDate",
      sortable: false,
      flex: 0.8,
      headerAlign: 'center',
      renderCell: (params) => renderEventDateCell(params, !params.row.isLoadingPurchases)
    },
    [REQUEST_HISTORY_GRID_COLUMN.STATUS]: {
      headerName: "STATUS",
      field: "requestStatusId",
      sortable: false,
      flex: 0.7,
      headerAlign: 'center',
      renderCell: (params) => {
        let value = displayStusName[params.value];
        if (params.value === BuyRequestStatus.Completed && params.row.stnPurchaseId) {
          let baseURL = STN_FE_URL
          baseURL += '#/purchase/edit';
          return <a href={`${baseURL}/${params.row.stnPurchaseId}`} className={value.className} target="_blank" rel="noreferrer">{value.text}</a>
        }
        else
          return <span className={value.className}>{value.text}</span>;
      }
    },
    [REQUEST_HISTORY_GRID_COLUMN.BUYER_NAME]: {
      headerName: "BUYER NAME",
      field: "buyerName",
      flex: 0.5,
      headerAlign: 'center',
      valueGetter: (params) => params.row.requestStatusId != BuyRequestStatus.Pending ? params.value : null,
      renderCell: v => v.row.isUsersLoadings ? <Skeleton variant="text" width="70%" /> : v.value,
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.QUANTITY]: {
      headerName: "QUANTITY",
      field: "quantity",
      flex: 0.1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.SECTION]: {
      headerName: "SECTION",
      field: "section",
      flex: 0.1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.ROW]: {
      headerName: "ROW",
      field: "row",
      flex: 0.1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.SEATS]: {
      headerName: "SEATS",
      field: "seats",
      flex: 0.1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.TOTAL_COST]: {
      headerName: "TOTAL COST",
      field: "totalCost",
      flex: 0.3,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.COST_PER_TICKETS]: {
      headerName: "$/TICKET",
      field: "pricePerTicket",
      flex: 0.3,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.REASON]: {
      headerName: "REASON",
      field: "reason",
      flex: 0.5,
      headerAlign: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.REWARD]: {
      headerName: "REWARD",
      field: "reward",
      flex: 0.4,
      headerAlign: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.APPROVED]: {
      headerName: "APPROVED/DISAPPROVED",
      field: "assignedManager",
      flex: 0.7,
      renderCell: v => v.row.isLoadingAssignedManagers.isLoading && !v.value ?
        <Skeleton variant="text" width="70%" />
        :
        v.row.isLoadingAssignedManagers.isError ?
          <span style={{ color: "var(--amber)" }}>{v.row.isLoadingAssignedManagers.errorMessage}</span>
          :
          v.value,
      headerAlign: 'center',
      sortable: false,
    },
    [REQUEST_HISTORY_GRID_COLUMN.MANAGE]: {
      field: 'actions',
      width: 28,
      minWidth: 20,
      type: 'actions',
      getActions: (params) => {
        if (params.row.requestStatusId === BuyRequestStatus.Completed && params.row.purchaseTransactionId && params.row.relatedTransactionLoading) {
          return params.row.relatedTransactionId ? [
            <GridActionsCellItem
              icon={<EditOutlinedIcon sx={{ fontSize: '1em', color: 'var(--orange)' }} />}
              onClick={x => onEditTransactionClick(params)}
              label="Edit transaction"
            />
          ] : [
            <GridActionsCellItem
              icon={<ReceiptLongOutlinedIcon sx={{ fontSize: '1em', color: 'var(--orange)' }} />}
              onClick={x => onAddTransactionButtonClick(x, params.row)}
              label="Add transaction"
            />
          ]
        }
        else {
          return [];
        }
      }
    },
    [REQUEST_HISTORY_GRID_COLUMN.ADDITIONAL_INFO_MANAGE]: {
      field: 'additionalActions',
      width: 28,
      minWidth: 20,
      type: 'actions',
      getActions: (params) => {
        if (params.row.requestStatusId === BuyRequestStatus.Completed) {
          return [
            <GridActionsCellItem
              icon={<NumbersOutlinedIcon sx={{ fontSize: '1em', color: 'var(--orange)' }} />}
              onClick={x => onAdditionalInfoModalClick(x, params.row.additionalParams)}
              label="Additional Info"
            />
          ]
        } else {
          return []
        }
      }
    }
  };

  const onColumnWidthChanged = ({ colDef, element, width }) => {
    const [key] = Object.entries(columnsDefinition).find(([key, column]) => column.field === colDef.field)

    let newStyle = gridStyle.map(style => {
      const isSelectedStyle = style.name === key

      return {
        ...style,
        width: isSelectedStyle ? Math.round(width) : style.width
      }
    });

    setGridStyle(newStyle);
  }

  const onColumnOrderChange = ({ column, oldIndex, targetIndex }) => {
    const [key] = Object.entries(columnsDefinition).find(([key, col]) => col.field === column.field)

    ++targetIndex; ++oldIndex;
    let newStyle = gridStyle.map(style => {
      const isSelectedStyle = style.name === key;
      const isPrevColumn = style.index === targetIndex;
      const styleIndex = style.index;

      if (isSelectedStyle) {
        return {
          ...style, index: targetIndex
        }
      } else {
        if (oldIndex < targetIndex && styleIndex > oldIndex && styleIndex <= targetIndex) {
          return {
            ...style, index: styleIndex - 1
          }
        } else if (oldIndex > targetIndex && styleIndex < oldIndex && styleIndex >= targetIndex) {
          return {
            ...style, index: styleIndex + 1
          }
        } else {
          return {
            ...style
          }
        }
      }
    });

    setGridStyle([...newStyle]);
  }

  const onIsTodayRequestChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.checked }));
    setSortEnabled(e.target.checked);
    setPaginationModel(prev => ({ ...prev, page: 0 }))
    onSearch({ ...filters, [e.target.name]: e.target.checked }, { ...paginationModel, page: 0 }, sortModel)
  }

  const onSortModelChange = (sortModel, data) => {
    setSortModel(sortModel);
    onSearch(filters, paginationModel, sortModel)
  }

  const onPaginationModelChange = (pageModel) => {
    if (isLoadingData)
      return;

    setPaginationModel(pageModel);
    onSearch(filters, pageModel, sortModel, true);
  }

  const onSelectChange = (e) => {
    handleFiltersChange(e);
    setPaginationModel(prev => ({ ...prev, page: 0 }));
    onSearch({ ...filters, [e.target.name]: e.target.value }, { ...paginationModel, page: 0 }, sortModel)
  }
  
  return (
    <Box sx={{ width: "100%", height: "74vh" }}>
      <Notification {...notification} handleClose={() => setNotification({ ...notification, snackBarOpenProp: false })} />

      {modalIsOpen == "addBonusTransaction" && <AddBonusTransactionModal isOpen={modalIsOpen == "addBonusTransaction"} setIsOpen={() => setModalIsOpen(null)} purchase={{ id: selectedAdditionalInfo?.purchaseId, transactionID: selectedAdditionalInfo?.purchaseTransactionId }} />}
      {modalIsOpen == "addErrorTransaction" && <AddErrorTransactionModal modalIsOpen={modalIsOpen == "addErrorTransaction"} setModalIsOpen={() => setModalIsOpen(null)} selectedTransaction={{ transactionID: selectedAdditionalInfo?.purchaseTransactionId }} />}
      
      {modalIsOpen == "editBonusTransaction" && <EditBonusTransactionModal isOpen={modalIsOpen == "editBonusTransaction"} setIsOpen={() => setModalIsOpen(null)} selectedTransaction={selectedAdditionalInfo?.relatedTransaction} />}
      {modalIsOpen == "editErrorTransaction" && <EditErrorTransactionModal modalIsOpen={modalIsOpen == "editErrorTransaction"} setModalIsOpen={() => setModalIsOpen(null)} selectedTransaction={selectedAdditionalInfo?.relatedTransaction} />}
      <Box>
        <h3>Request History</h3>
      </Box>
      <Box sx={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
        <Grid container columnSpacing={1} rowSpacing={0}>
          <Grid item xs={3}>
            <TextField fullWidth placeholder="Search..." value={filters?.searchValue} name="searchValue" disabled={isLoadingData}
              onChange={handleFiltersChange}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  setPaginationModel(prev => ({ ...prev, page: 0 }))
                  onSearch(filters, { ...paginationModel, page: 0 }, sortModel)
                }
              }} />
          </Grid>

          <Grid item xs={3}>
            <Select sx={{ width: "100%", height: '41px' }} value={filters?.searchStatusId} name="searchStatusId" disabled={isLoadingData} onChange={onSelectChange}>
              {
                Object.keys(dropdownSearchValue).map((key, value) => {
                  return (
                    <MenuItem key={key} value={key}>
                      {dropdownSearchValue[key].text}
                    </MenuItem>
                  )
                })
              }
            </Select>
          </Grid>

          <Grid item xs={6}>
            <Button sx={{ width: '100px' }} variant="contained" disabled={isLoadingData} onClick={() => { onSearch(filters, paginationModel, sortModel) }}>Search</Button>
          </Grid>

          <Grid item>
            <FormControlLabel disabled={isLoadingData} control={<Checkbox checked={filters?.isTodayRequest} name="isTodayRequest" onChange={onIsTodayRequestChange} />} label="Show only today's requests" />
          </Grid>
        </Grid>
      </Box>

      <AdditionalInfoPopper
        open={isAdditionalInfoOpened}
        anchorEl={rowAnchorEl}
        additionalInfo={selectedAdditionalInfo}
        onClose={onAdditionalInfoModalClosed}
      />

      <AddTransactionMenuPopper
        open={isAddTransactionMenuOpened}
        anchorEl={rowAnchorEl}
        additionalInfo={selectedAdditionalInfo}
        onClose={OnAddTransactionMenuClosed}
      />

      <Box sx={{ height: "100%" }}>
        <DataGridPremium
          rows={rows}
          columns={displayColumns}
          rowHeight={28}
          columnHeaderHeight={30}
          getRowId={r => r.buyRequestId}
          pagination
          disableColumnSelector
          disableMultipleRowSelection
          disableColumnMenu
          hideFooterSelectedRowCount
          checkboxSelection={false}
          disableRowGrouping={true}
          disableAggregation={true}
          disableColumnFilter={true}
          disableMultipleColumnsSorting={true}
          isRowSelectable={() => false}
          sx={{
            ['& .MuiDataGrid-main']: {
              fontSize: "14px",
            }
          }}

          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}

          loading={isLoadingData}

          page={paginationModel.page}
          pageSize={paginationModel.pageSize}
          rowCount={totalElements}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}

          paginationMode="server"

          onColumnWidthChange={onColumnWidthChanged}
          onColumnOrderChange={onColumnOrderChange}
        />
      </Box>
    </Box>
  )
}

export default RequestHistory;